/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { memo, useEffect, useState } from 'react'
import { FormHelperText } from '@maas-components/core'
import PropTypes from 'prop-types'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TouchBackend } from 'react-dnd-touch-backend'
import { Box, Grid } from 'core/components/Core'
import { useUpload } from '../context'
import { isTouchDevice } from '../utils'
import Dropzone from './Dropzone'
import File from './File'
import ProductInfoDnd from './ProductInfoDnD'

const backendForDND = isTouchDevice() ? TouchBackend : HTML5Backend
function ProductUploadContent({ error, errorMessage, hasLabels, hasWarning, checkDependencies }) {
  const [stateUpload] = useUpload()
  const [refreshComponent, setRefreshComponent] = useState(1)
  const renderProductUploadInfo = () => {
    if (!hasLabels) {
      return null
    }
    return <ProductInfoDnd />
  }

  useEffect(() => {
    // eslint-disable-next-line no-param-reassign, no-return-assign
    setRefreshComponent(prev => (prev += 1))
  }, [stateUpload])

  return (
    <Box mt={2} key={refreshComponent}>
      {stateUpload.FILES.length ? (
        <DndProvider backend={backendForDND} context={window}>
          <Grid container spacing={2}>
            <Dropzone type="card" error={error} />
            {stateUpload.FILES.map((file, index) => (
              <File
                key={`${file?.id}`}
                data={file}
                index={index}
                hasWarning={hasWarning}
                checkDependencies={checkDependencies}
              />
            ))}
          </Grid>
          {renderProductUploadInfo()}
        </DndProvider>
      ) : (
        <>
          <Dropzone error={error} />
          {error && <FormHelperText error={error}>{errorMessage}</FormHelperText>}
        </>
      )}
    </Box>
  )
}

ProductUploadContent.propTypes = {
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  hasLabels: PropTypes.bool,
  hasWarning: PropTypes.bool,
  checkDependencies: PropTypes.bool,
}

ProductUploadContent.defaultProps = {
  error: false,
  errorMessage: '',
  hasLabels: false,
  hasWarning: false,
  checkDependencies: false,
}

export default memo(ProductUploadContent)
